import { createSelector } from "reselect";
import { assessmentVersionSelector } from "src/selectors/config_selectors";

export const bwatScoreEnabledSelector = createSelector(
  assessmentVersionSelector,
  version => version == "v5Bwat" || version == "v5Ashn" || version == "v6MayoClinic" || version == "v5LHC"
);
